export const NOTIFICATION_TYPE = {
  BILLING_PORTAL_PAYMENT_METHODS_REFRESH: 'billingPortalPaymentMethodsRefresh',
  BILLING_PORTAL_PAYMENT_COMPLETE: 'billingPortalPaymentComplete',
  BILLING_PORTAL_BATCH_PAYMENT_COMPLETE: 'billingPortalBatchPaymentComplete',
};
